module.exports = __webpack_public_path__ + "img/edge2.f83aa654.jpg";